import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  ScrollArea,
} from '@ais-ui/ui-core';

import React, { useMemo, useState } from 'react';
import {
  WordpressArticle,
  ArticleContentItemRenderer,
  cn,
} from '@ais-ui/utils';
import { categoryToIcon } from './categoryToIcon';
import { v4 as uuidv4 } from 'uuid';

interface ArticleListProps {
  articles: WordpressArticle[];
}

interface FilterItemProps {
  article: WordpressArticle;
}

const ArticleItem = ({ article }: FilterItemProps) => {
  const ArticleIcon = useMemo(
    () => categoryToIcon(article.categories),
    [article],
  );

  return (
    <AccordionItem
      key={article.id}
      value={article.id.toString()}
      className={cn('pr-6')}
    >
      <AccordionTrigger>
        <div className="flex items-center">
          <div className="relative overflow-visible">
            <ArticleIcon className="size-8" />
          </div>
          <div className="ml-4 space-y-1">
            <p className="text-lg text-left font-normal leading-none group-hover:underline">
              {article.title.rendered}
            </p>
            <p className="text-md text-left font-normal text-muted-foreground">
              {article.subtitle}
            </p>
          </div>
        </div>
      </AccordionTrigger>
      <AccordionContent>
        {article.acf.marinepulse_content &&
          article.acf.marinepulse_content.map((articleContentItem) => (
            <ArticleContentItemRenderer
              key={uuidv4()}
              articleContentItem={articleContentItem}
            ></ArticleContentItemRenderer>
          ))}
      </AccordionContent>
    </AccordionItem>
  );
};

export const ArticleList = ({ articles }: ArticleListProps) => {
  return (
    <Accordion
      className="flex-1 flex flex-col overflow-hidden"
      type="single"
      collapsible
    >
      <ScrollArea
        observeResize={false}
        className="p-0 overflow-y-auto md:h-[700px] lg:[1200px] overflow-hidden"
      >
        {articles
          .slice()
          .sort((a, b) =>
            (a.title?.rendered || '').localeCompare(b.title?.rendered || ''),
          )
          .map((article) => (
            <ArticleItem key={article.id} article={article} />
          ))}
      </ScrollArea>
    </Accordion>
  );
};
